<template>
  <div>
    <table
      v-intersect.once
      class="youtube-list__table">
      <thead class="youtube-list__thead">
        <tr>
          <th class="youtube-list__cell-thumbnail">アーティスト</th>
          <th class="youtube-list__cell-title">楽曲</th>
          <th class="youtube-list__cell-date">ISRC</th>
          <th class="youtube-list__cell-select"></th>
        </tr>
      </thead>
      <tbody
        v-if="items && items.length > 0"
        class="youtube-list__tbody">
        <tr
          v-for="item in items"
          :key="item.id">
          <td>
            {{ item.metadata.artist[0] }}
          </td>
          <td style="text-align: left">
            <div>{{ item.metadata.title }}</div>
          </td>
          <td>
            {{ item.metadata.isrc }}
          </td>
          <td>
            <a
              v-if="!item.claimed"
              href="#"
              class="c-btn c-btn--small"
              @click.prevent="onRowClicked(item.id)">
              {{ selectButtonText }}
            </a>
            <a
              v-else
              href="#"
              disabled
              class="c-btn c-btn--small c-btn--back">
              申請済み
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import moment from 'moment/moment'

export default {
  name: 'YouTubeAssetsAssetTable',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectButtonText: {
      type: String,
      required: false,
      default: '選択',
    },
  },
  computed: {
    moment() {
      return moment
    },
  },
  methods: {
    onRowClicked(id) {
      this.$emit('row-clicked', id)
    },
  },
}
</script>

<style scoped>

</style>
